import { render } from "./Empty.vue?vue&type=template&id=e87ce6c8&scoped=true"
import script from "./Empty.vue?vue&type=script&lang=js"
export * from "./Empty.vue?vue&type=script&lang=js"

import "./Empty.vue?vue&type=style&index=0&id=e87ce6c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e87ce6c8"]])

export default __exports__